import { FormControl, FormHelperText, InputLabel, LinearProgress, MenuItem } from '@material-ui/core'
import { ErrorMessage, Field, useFormikContext } from 'formik'
import { Select } from 'formik-material-ui'
import React, { memo } from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'

const makeSilosDestinoParaTransileSelector = () =>
  createSelector((state, { cereal, variedad }) => { return (state.movimientos.estadoSilos.silos.filas || []).filter(silo => silo.cereal === cereal && silo.cerealVariedad === variedad && (silo.estado === 'U' || silo.estado === 'V')).map((silo) => silo.nombreCorto) },
    _ => _
  )

const makeMapStateToProps = () => (state, ownProps) => ({
  loadingSilos: state.movimientos.estadoSilos.loading,
  silosDestino: makeSilosDestinoParaTransileSelector()(state, ownProps)
})

export const SiloDestinoParaTransileSelect = connect(makeMapStateToProps)(
  memo(({ loadingSilos, silosDestino }) => {
    const {
      errors: { siloDestino: error }
    } = useFormikContext()
    return (
      <FormControl style={{ width: '100%' }} variant='outlined' error={!!error}>
        <InputLabel id='siloDestino-label'>Silo Destino</InputLabel>
        <Field
          component={Select}
          name='siloDestino'
          label='Silo Destino'
          inputProps={{
            labelId: 'siloDestino-label',
            id: 'siloDestino'
          }}
        >
          {(silosDestino || []).map((silo) => (
            <MenuItem key={silo} value={silo}>
              {silo}
            </MenuItem>
          ))}
        </Field>
        {loadingSilos && <LinearProgress />}
        <ErrorMessage name='siloDestino'>{(error) => <FormHelperText>{error}</FormHelperText>}</ErrorMessage>
      </FormControl>
    )
  })
)
